import React, { useCallback, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Breadcrumbs } from "./Breadcrumbs"
import type { Crumb, RouteBreadcrumbsProps } from "./types"

export const RouteBreadcrumbs = React.forwardRef<
  HTMLDivElement,
  RouteBreadcrumbsProps
>(({ mainPageTitle, overrideCrumb, inserts = [], ...otherProps }, ref) => {
  const _navigate = useNavigate()
  const location = useLocation()

  const landingTitle = mainPageTitle ?? "Dashboard"

  const [crumbs, setCrumbs] = useState<Crumb[]>([])

  const updateCrumbs = useCallback(
    (pathname: string) => {
      const subpaths = pathname.split("/").filter((x) => x !== "")
      const subpathURLs = ["/"]

      subpaths.forEach((path, index) =>
        subpathURLs.push(subpathURLs[index].concat(path, "/")),
      )

      const routeCrumbs: Crumb[] = [{ text: landingTitle, href: "/" }]
      subpaths.forEach((path, index) => {
        let overridden: Partial<Crumb> | null = null
        if (typeof overrideCrumb !== "undefined") {
          overridden = overrideCrumb(path, index, subpaths.length)
          if (overridden === null) return
        }

        routeCrumbs.push({
          text: path,
          href: subpathURLs[index + 1],
          ...overridden,
        })

        const insertHere = inserts.filter((insert) => insert.index === index)
        if (!insertHere.length) return

        routeCrumbs.push(...insertHere.map(({ crumb }) => crumb))
      })

      setCrumbs(routeCrumbs)
    },
    [landingTitle, overrideCrumb],
  )

  useEffect(() => {
    updateCrumbs(location.pathname)
  }, [location, updateCrumbs])

  return <Breadcrumbs ref={ref} crumbs={crumbs} {...otherProps} />
})
